import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { AMBER, FONT_MONO, Reveal, TEAL } from './LandingKit';

const items = [
  { icon: <PhoneIphoneRoundedIcon fontSize="small" />, label: 'Sem rastreador por veículo' },
  { icon: <LocationOnRoundedIcon fontSize="small" />, label: 'Sem instalação em campo' },
  { icon: <QueryStatsRoundedIcon fontSize="small" />, label: 'Coletas em tempo real' },
  { icon: <WhatsAppIcon fontSize="small" />, label: 'Operação consultável no WhatsApp' },
];

const hairlineSx = (theme) => ({
  border: 0,
  height: '1px',
  margin: 0,
  background: `linear-gradient(90deg, transparent, ${TEAL}33 18%, ${TEAL}33 82%, transparent)`,
  ...theme.applyStyles('dark', {
    background: `linear-gradient(90deg, transparent, ${TEAL}40 18%, ${TEAL}40 82%, transparent)`,
  }),
});

export default function TrustBar() {
  return (
    <Box id="trustbar" sx={{ py: { xs: 5, sm: 7 } }}>
      <Container>
        <Reveal>
          <Box component="hr" aria-hidden sx={hairlineSx} />
          <Grid container spacing={2} sx={{ justifyContent: 'center', py: { xs: 3, sm: 3.5 } }}>
            {items.map((item, i) => {
              const accent = i % 2 ? AMBER : TEAL;
              return (
                <Grid size={{ xs: 6, md: 3 }} key={item.label}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    useFlexGap
                    sx={{ alignItems: 'center' }}
                  >
                    <Box
                      aria-hidden
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        width: 34,
                        height: 34,
                        borderRadius: 1.5,
                        color: accent,
                        border: '1px solid',
                        borderColor: `${accent}44`,
                        backgroundColor: `${accent}14`,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      sx={(theme) => ({
                        fontFamily: FONT_MONO,
                        fontSize: 12,
                        lineHeight: 1.35,
                        letterSpacing: '0.04em',
                        color: '#33514c',
                        ...theme.applyStyles('dark', { color: '#9fc4bd' }),
                      })}
                    >
                      {item.label}
                    </Typography>
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
          <Box component="hr" aria-hidden sx={hairlineSx} />
        </Reveal>
      </Container>
    </Box>
  );
}
